import { apiGet, apiPost, apiPostForm } from "@/services/api/httpClient";

export interface VoiceStatusResponse {
  configured: boolean;
  readyForAsr: boolean;
  readyForTts: boolean;
  mode: string;
  message: string;
}

export interface AsrResponse {
  transcript: string;
  provider: string;
  meta: Record<string, unknown>;
}

export interface TtsResponse {
  audioBase64: string;
  mimeType: string;
  provider: string;
  meta: Record<string, unknown>;
}

export function fetchVoiceStatus(signal?: AbortSignal): Promise<VoiceStatusResponse> {
  return apiGet("/voice/status", signal);
}

export function recognizeSpeech(audio: Blob, signal?: AbortSignal): Promise<AsrResponse> {
  const form = new FormData();
  const filename = audio.type.includes("ogg")
    ? "agent-input.ogg"
    : audio.type.includes("mpeg") || audio.type.includes("mp3")
      ? "agent-input.mp3"
      : "agent-input.webm";
  form.append("audio", audio, filename);
  return apiPostForm("/voice/asr", form, signal);
}

export function synthesizeSpeech(text: string, signal?: AbortSignal): Promise<TtsResponse> {
  return apiPost("/voice/tts", { text }, signal);
}

export function playBase64Audio(audioBase64: string, mimeType = "audio/mpeg"): HTMLAudioElement | null {
  if (!audioBase64) return null;
  const audio = new Audio(`data:${mimeType};base64,${audioBase64}`);
  void audio.play().catch(() => undefined);
  return audio;
}
